import { BucketType } from '../types';

export const DEFAULT_BUCKET_INDEX = 0;
export const ALLOWED_BUCKETS_STRING = /\d{1,2}/;

/** Validates whether a bucket isn't a restricted value */
export function validateBucket(buckets: string[]): BucketType {
	if (buckets.map((bucket) => !ALLOWED_BUCKETS_STRING.test(bucket)).some(Boolean)) {
		return BucketType.Invalid;
	}

	return BucketType.Valid;
}

export function validateCustomBucket(validateFunc: () => boolean) {
	if (typeof validateFunc !== 'function') {
		return BucketType.Invalid;
	}

	if (validateFunc()) {
		return BucketType.Valid;
	}

	return BucketType.Invalid;
}

/** Get list of overlapping buckets */
export function checkForBucketOverlap(buckets: Array<string>): Array<string> {
	// no buckets, nothing to do
	if (!buckets?.length) {
		return [];
	}

	// count the frequency of each bucket
	const matches = {};

	for (const bucket of buckets) {
		matches[bucket] = (matches[bucket] || 0) + 1;
	}

	return buckets.filter((bucket) => matches[bucket] > 1);
}
